import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Container, Grid, Box, Card, useTheme, Typography, useMediaQuery } from "@mui/material";

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import QRCodeDisplay from "../components/QRCodeDisplay"; // Import the QRCodeDisplay component



// const crypto = require('crypto-browserify');
const { encryptPayload } = require("../utils/custom-hash");

function Main() {
  const navigate = useNavigate();
  const location = useLocation();
  const [services, setServices] = useState([]);
   const [groups, setGroups] = useState([]);
  const [setInactiveServices] = useState([]);
  const [branchId, setBranchId] = useState(null);
  const [branchDetails, setBranchDetails] = useState(null);
  const [showQRCode, setShowQRCode] = useState(false); // State to manage QR code visibility
  const [qrValue, setQrValue] = useState(""); // State to hold QR code value
  const [isEnable, setIsEnable] = useState(false); // State to manage QR code visibility
  const [APP_VERSION, setAPP_VERSION] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Detect small screen size

  // Update the time every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Update every second

    return () => clearInterval(intervalId); // Clean up the interval on component unmount
  }, []);

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthsOfYear = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const dayOfWeek = daysOfWeek[currentDate.getDay()];
  const dayOfMonth = currentDate.getDate();
  const month = monthsOfYear[currentDate.getMonth()];
  const year = currentDate.getFullYear();
  const time = currentDate.toLocaleTimeString();

  const ordinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const formattedDate = `${dayOfWeek} ${dayOfMonth}${ordinalSuffix(dayOfMonth)}, ${month} ${year} ${time}`;

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    let branchIdFromUrl =
      queryParams.get("branch") || localStorage.getItem("branchId");

      setInterval(() => {
        branchIdFromUrl = queryParams.get("branch") || localStorage.getItem("branchId");
      }, 300000); // 5 minutes = 300,000 milliseconds
      

    if (branchIdFromUrl) {
      setBranchId(branchIdFromUrl);
      localStorage.setItem("branchId", branchIdFromUrl);

      const fetchServices = async () => {
        try {
          const checkUrl = `${process.env.REACT_APP_ASERVER}/api/kiosk/services/${branchIdFromUrl}`;
          const response = await fetch(checkUrl, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
            const data = await response.json();
            if (data.success && data.data) {
              //console.log(data.data);
               const result = data.data;
               const groupsData = result.groups || [];  
                const allServices = result.services || [];
               // Get all service IDs that are part of any group
        const groupedServiceIds = new Set(groupsData.flatMap(group => group.services.map(service => service.serviceId)));
  
        // Filter services that are NOT part of any group
        const standaloneServices = allServices.filter(service => !groupedServiceIds.has(service.serviceId));
              setGroups(groupsData);
              setServices(standaloneServices);
              setInactiveServices(allServices.filter(service => !service.isActive));
              if (!branchIdFromUrl) {
                navigate(`/`, {
                  state: {
                    services: data.services,
                    branchId: branchIdFromUrl,
                  },
                });
              }
            } else {
              console.error(
                "Failed to fetch services: ",
                data.message || "Unknown error"
              );
            }
          } else {
            const errorText = await response.text();
            console.error("Expected JSON, but got:", errorText);
          }
        } catch (error) {
          console.error("Error checking feedback status:", error);
        }
      };

      fetchServices();
    }
  }, [location, navigate]);

  // useEffect(() => {
  //   const fetchBranchDetails = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_ASERVER}/api/kiosk/branches/${branchId}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (!response.ok) {
  //         setIsEnable(false);
  //         throw new Error("Network response was not ok");
  //       }

  //       const result = await response.json();
  //       console.log("BRANCH result:", result);
  //       console.log("branchId:", branchId);

  //       // Directly access the branchId from the result.branch object
  //       const branchIdFromResponse = result.branch.branchId;
  //       console.log("branchId from response:", branchIdFromResponse);

  //       // You can now use this branchIdFromResponse as needed
  //       if (branchIdFromResponse) {
  //         setIsEnable(true);
  //         setBranchDetails(result.branch);
  //       } else {
  //         console.error("No branchId found in the response");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching branches:", error);
  //       alert("Failed to fetch branch details.");
  //     }
  //   };

  //   if (branchId) {
  //     fetchBranchDetails();
  //   }
  // }, [branchId]);


  useEffect(() => {
    if (!branchId) return; // Prevent API call if branchId is missing

    const fetchBranchDetails = async () => {
      try {
        setIsEnable(true); // Show "Loading branch details..." immediately

        const response = await fetch(
          `${process.env.REACT_APP_ASERVER}/api/kiosk/branches/${branchId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
       // console.log("BRANCH result:", result);

        if (result?.branch?.branchId) {
          setBranchDetails(result.branch);
        } else {
          setIsEnable(false);
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
        setIsEnable(false);
        alert("Failed to fetch branch details.");
      }
    };
 const fetchVersionNumber = async () => {
      try {
       
        const response = await fetch(`${process.env.REACT_APP_ASERVER}/api/kiosk/buildVersion/latestVersion`);
        if (!response.ok) console.log("Network response was not ok");

        const data = await response.json();
        setAPP_VERSION(data.versionNumber);
      } catch (error) {
        console.error("Failed to fetch services:", error);
      }
    };
    fetchBranchDetails();
     fetchVersionNumber();
  }, [branchId]);



  const handleGenerateTicketClick = () => {
    if (isEnable === true) {
      navigate("/services", {
        state: { groups,services, branchDetails },
      });
    }

  };

  const handleProvideConfirmationCodeClick = () => {
    if (isEnable === true) {
      navigate("/confirm-code", {
        state: { branchDetails },
      });
    }

  };

  const handleTakeTicketReceiptClick = () => {
    if (isEnable === true) {
      navigate("/print-receipt", {
        state: { branchDetails },
      });
    }
  };

  const handleQRCodeBarCodeClick = async () => {
    // Set the QR code value and show the QR code display
    if (isEnable === true) {
      try {

        //console.log('QR branchDetails', branchDetails);
        // alert(localStorage.getItem("branchId"))
        // const encryptedBranchId = await encryptPayload( localStorage.getItem("branchId"));
        // console.log("Encrypted Branch ID:", encryptedBranchId);

        const queryParams = new URLSearchParams(location.search);
        let branchIdFromUrl =
        await queryParams.get("branch") || localStorage.getItem("branchId");
         //alert(branchIdFromUrl)
         if(!branchIdFromUrl){
          return false;
         }
        const encryptedBranchId = await encryptPayload(branchIdFromUrl);
        //console.log("Encrypted Branch ID:", encryptedBranchId);

        const response = await fetch(
          `${process.env.REACT_APP_ASERVER}/api/kiosk/qrcode/${branchId}`,
          {
            method: "POST",
            body: JSON.stringify({
              
              // url: `http://localhost:3042/kiosk/customer-form?branchId=${branchId}`
              url: `${process.env.REACT_APP_QUEUE_TRACKING_CLIENT}/?token=${encodeURIComponent(encryptedBranchId)}`,
              // url: `${process.env.REACT_APP_ASERVER}/qr-ticket-generator?branchId=${branchId}`
            }),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        // console.log("BRANCH result:", result);
        // console.log("branchId:", branchId);

        setQrValue(result.qrCode);
      } catch (error) {
        console.error("Error generating QR code:", error);
      }
      // setQrValue('https://example.com'); // Replace with dynamic QR code value
      setShowQRCode(true);
    }
  };

  const handleQRCodeClose = () => {
    // Close the QR code display
    setShowQRCode(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundImage: `linear-gradient(
          to right,
          rgba(6, 78, 180, 0.85) 0%,     /* dark blue - left */
          rgba(34, 97, 221, 0.45) 50%, /* light blue - center */
          rgba(6, 78, 180, 0.85) 100%   /* dark blue - right */
        ),
      url("/assests/bookonline-bg.jpeg")`,
      //  background: "radial-gradient(circle, #5AD2F4, #064EB4)",
       backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <div
  style={{
    position: "absolute",
    top: 20,
    left: 20,
    backgroundColor: "#FFFFFF",   // white background ONLY for logo
    padding: "10px 12px",         // space around logo
    borderRadius: "8px",          // rounded corners
    zIndex: 10
  }}
>
  <img
    src="/assests/JN_F_Logo.png"
    alt="Company Logo"
    style={{
      width: 200,   // increase or reduce size
      height: "70px",
      display: "block"
    }}
  />
</div>

      <Container>
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            display: 'flex',
            alignItems: 'center',
            mt: isSmallScreen ? 1 : 0
          }}
        >
          <AccessTimeIcon sx={{ color: '#fff' }} />
          <Typography sx={{ marginLeft: 1, color: '#fff' }}>
            {formattedDate}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 4,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: "white",
              mb: 3,
              fontFamily: "Roboto, sans-serif", // Apply the Google Font
            }}
          >
            Welcome!
          </Typography>
          {branchDetails ? (
            <Typography variant="h5" sx={{ color: "white" }}>
              {branchDetails.branchName}
            </Typography>
          ) : (

            <Typography variant="h6" sx={{ color: "white" }}>
              {isEnable ? (
                <> Loading branch details... </>
              ) : (
                <>Branch Inactive </>
              )}
            </Typography>
          )}
        </Box>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} md={8} container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: 3,
                  boxSizing: "border-box",
                  backgroundColor: "#e0e0e0",
                  "&:hover": {
                    backgroundColor: "white", // Change background color on hover
                    transform: "scale(1.05)", // Slightly increase size on hover
                    transition: "0.3s", // Smooth transition
                  },
                }}
                onClick={handleProvideConfirmationCodeClick}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    textAlign: "left",
                    flexGrow: 1,
                    color: "#333", // Dark grey color
                  }}
                >
                Appointment Check-in
                </Typography>
                <ArrowForwardIosIcon sx={{ color: "primary.main" }} />
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: 3,
                  boxSizing: "border-box",
                  backgroundColor: "#e0e0e0",
                  "&:hover": {
                    backgroundColor: "white", // Change background color on hover
                    transform: "scale(1.05)", // Slightly increase size on hover
                    transition: "0.3s", // Smooth transition
                  },
                }}
                onClick={handleGenerateTicketClick}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#333", // Dark grey color
                  }}
                >
                  Generate Ticket
                </Typography>
                <ArrowForwardIosIcon sx={{ color: "primary.main" }} />
              </Card>
            </Grid>
          </Grid>
          <Grid item xs={12} md={8} container spacing={2}>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: 3,
                  boxSizing: "border-box",
                  backgroundColor: "#e0e0e0",
                  "&:hover": {
                    backgroundColor: "white", // Change background color on hover
                    transform: "scale(1.05)", // Slightly increase size on hover
                    transition: "0.3s", // Smooth transition
                  },
                }}
                onClick={handleTakeTicketReceiptClick}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#333", // Dark grey color
                  }}
                >
                  Reprint Ticket Receipt
                </Typography>
                <ArrowForwardIosIcon sx={{ color: "primary.main" }} />
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: 3,
                  boxSizing: "border-box",
                  backgroundColor: "#e0e0e0",
                  "&:hover": {
                    backgroundColor: "white", // Change background color on hover
                    transform: "scale(1.05)", // Slightly increase size on hover
                    transition: "0.3s", // Smooth transition
                  },
                }}
                onClick={handleQRCodeBarCodeClick}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    textAlign: "left",
                    flexGrow: 1,
                    color: "#333", // Dark grey color
                  }}
                >
                  QR Code / Bar Code
                </Typography>
                <ArrowForwardIosIcon sx={{ color: "primary.main" }} />
              </Card>
            </Grid>
          </Grid>
        </Grid>
        {showQRCode && (
          <QRCodeDisplay value={qrValue} branchName={branchDetails.branchName} onClose={handleQRCodeClose} />
        )}

        <Typography
          variant="body2"
          sx={{
            position: "absolute",
            bottom: 10,
            right: 10,
            color: "white",
            fontWeight: "bold",
          }}
        >
         {APP_VERSION}
        </Typography>


      </Container>
    </Box>
  );
}

export default Main;
